import styled from 'styled-components';
import { breakpoints, font } from '@chegg-ui/theme';
export var CardDescription = styled.span.withConfig({
  componentId: "sc-dyefjh-0"
})(["font-family:", ";font-size:", ";margin-left:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;@media screen and (min-width:", "){max-width:200px;}"], font.family.aspira, font.size.px16, breakpoints.lg.min);
export var PaddedContainer = styled.div.withConfig({
  componentId: "sc-dyefjh-1"
})(["align-items:center;display:flex;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/MopDisplayContent/styled.js
// module id = 4566
// module chunks = 11